import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ill_pakket_full.svg'
import _imports_1 from '@/app/ui/assets/svg/ill_pakket_full_green.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-da82d610")

_pushScopeId("data-v-da82d610")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "corner-image",
  src: _imports_0,
  alt: "pakket_full"
}
const _hoisted_3 = {
  key: 1,
  class: "corner-image",
  src: _imports_1,
  alt: "pakket_full"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")!

  return (_openBlock(), _createBlock("section", {
    class: ["summary-card", _ctx.decideBgColor]
  }, [
    _createVNode(_component_Title, {
      title: _ctx.posName,
      class: "overflow-hidden overflow-ellipsis whitespace-nowrap",
      label: _ctx.posName
    }, null, 8, ["title", "label"]),
    _createVNode("div", {
      title: `${_ctx.current}/${_ctx.total}`,
      class: ["counter", _ctx.decideBgColor]
    }, [
      _createTextVNode(_toDisplayString(_ctx.current) + " ", 1),
      (_ctx.sttOverdue.toLowerCase() !== 'late')
        ? (_openBlock(), _createBlock("span", _hoisted_1, "/" + _toDisplayString(_ctx.total), 1))
        : _createCommentVNode("", true)
    ], 10, ["title"]),
    _createVNode("button", {
      class: "button-action",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('action')))
    }, _toDisplayString(_ctx.$t('sti.updateSti.seeMore')), 1),
    (['red', 'yellow'].includes(_ctx.decideBgColor))
      ? (_openBlock(), _createBlock("img", _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.decideBgColor === 'green')
      ? (_openBlock(), _createBlock("img", _hoisted_3))
      : _createCommentVNode("", true)
  ], 2))
})